import {
  selectCameraEnabled,
  useLiveSettingsActions,
  useLiveStore,
} from "../../store";

export const useHMSCamera = () => {
  const isCameraEnabled = useLiveStore(selectCameraEnabled);
  const { toggleCamera } = useLiveSettingsActions();

  return {
    isCameraEnabled,
    isCameraPending: false,
    toggleCamera,
  };
};
